import clsx from 'clsx';
import BridgeCard from './BridgeCard';
import { EXTERNAL_BRIDGES } from './config';

const ExternalBridgesInfo: React.FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <div className={clsx('text-center', className)}>
      <div className="font-bold text-white mb-1">Third-Party Bridges</div>
      <div className="text-smallRegular text-[#D9D9D9] mb-2">
        Can&apos;t find the network you&apos;re looking for? Try these
        third-party bridges:
      </div>
      <div className="gap-2 tablet:grid tablet:grid-cols-2 mobile:flex mobile:flex-col">
        {EXTERNAL_BRIDGES.map((bridge) => (
          <BridgeCard key={bridge.name} {...bridge} />
        ))}
      </div>
    </div>
  );
};

export default ExternalBridgesInfo;
